export const setAtTop = status => (dispatch, getState) => {
  if (getState().scroll.atTop !== status) {
    dispatch({
      type: 'SCROLL/AT_TOP',
      payload: status,
    })
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Scroll/Scroll.actions.js